import React, { useEffect, useState } from 'react';
import { getTrends } from '../services/api';
import useFadeIn from '../hooks/useFadeIn';
import '../css/sections.css';

const FALLBACK_TRENDS = [
  { _id:'1',  topic:'#WomenInLeadership',   icon:'👑', count: 4200 },
  { _id:'2',  topic:'#BusinessStrategy',    icon:'📊', count: 3800 },
  { _id:'3',  topic:'#HealthcareLeaders',   icon:'🏥', count: 2900 },
  { _id:'4',  topic:'#EducationFuture',     icon:'🎓', count: 2500 },
  { _id:'5',  topic:'#SustainableGrowth',   icon:'🌱', count: 2200 },
  { _id:'6',  topic:'#TechInnovation',      icon:'💡', count: 3100 },
  { _id:'7',  topic:'#GlobalLeadership',    icon:'🌍', count: 3600 },
  { _id:'8',  topic:'#FounderJourneys',     icon:'🚀', count: 2800 },
  { _id:'9',  topic:'#WomenEntrepreneurs',  icon:'✨', count: 4100 },
  { _id:'10', topic:'#CorporateCulture',    icon:'🤝', count: 1900 },
  { _id:'11', topic:'#FutureOfWork',        icon:'💼', count: 2600 },
  { _id:'12', topic:'#MindfulLeadership',   icon:'🧠', count: 1800 },
];

function formatCount(n) {
  if (n >= 1000) return (n / 1000).toFixed(1) + 'k';
  return String(n);
}

export default function Trends() {
  const [trends, setTrends] = useState(FALLBACK_TRENDS); // pre-populate
  const ref = useFadeIn(true);

  useEffect(() => {
    getTrends()
      .then(r => {
        const data = r.data?.data;
        if (data?.length) setTrends(data);
      })
      .catch(() => {/* keep FALLBACK_TRENDS */});
  }, []);

  return (
    <section className="sec" id="trends" ref={ref}>
      <div className="wrap">
        <div className="sec-head">
          <h2 className="sec-title fade-in">Trending Topics</h2>
          <p className="sec-sub fade-in">
            What the leadership community is reading and discussing right now.
          </p>
        </div>

        <div className="trends-grid" role="list">
          {trends.map(t => (
            <button
              key={t._id}
              className="trend-pill fade-in"
              role="listitem"
              aria-label={`${t.topic} — ${formatCount(t.count)} engagements`}
            >
              <span className="trend-icon" aria-hidden="true">{t.icon}</span>
              <span>{t.topic}</span>
              <span className="trend-count" aria-hidden="true">{formatCount(t.count)}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
